"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Search_1 = tslib_1.__importDefault(require("@mui/icons-material/Search"));
const InputAdornment_1 = tslib_1.__importDefault(require("@mui/material/InputAdornment"));
const TextField_1 = tslib_1.__importDefault(require("@mui/material/TextField"));
const styles_1 = require("@mui/material/styles");
const utils_1 = require("@mui/material/utils");
const ColumnSearch = (props) => {
    const { placeholder } = (0, styles_1.useThemeProps)({ props, name: "ColumnSelectorSearch" });
    return (react_1.default.createElement(TextField_1.default, { fullWidth: true, margin: "normal", InputProps: {
            startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" },
                react_1.default.createElement(Search_1.default, null))),
        }, size: "small", variant: "outlined", ...props, placeholder: placeholder, onChange: props?.onChange ? (0, utils_1.debounce)(props?.onChange, 250) : null }));
};
exports.default = ColumnSearch;
